import { PublicButton } from '@yes.technology/react-toolkit'
import { getPublicButtonRest, isPublicButton } from 'shared/utils'
import { Link, StyledButton } from './styles'
import {
  LinkButtonProps,
  SupportBannerProps
} from './SupportBannerContainer.types'

export type SupportBannerButton = {
  button?: SupportBannerProps['button']
}

const SupportBannerButton = ({ button }: SupportBannerButton) => {
  if (isPublicButton(button)) {
    return (
      <PublicButton
        href={button?.link?.url ?? button?.href ?? button?.href}
        target={button?.link?.target ?? button?.target ?? '_self'}
        {...getPublicButtonRest(button)}
        style={button?.style}
      >
        {button?.label ?? ''}
      </PublicButton>
    )
  }

  const linkButton = button as LinkButtonProps

  return (
    <Link href={linkButton?.href ?? '#'}>
      <StyledButton
        variant='secondary'
        heightClass='large'
        style={linkButton?.style}
      >
        {linkButton?.label ?? ''}
      </StyledButton>
    </Link>
  )
}

export default SupportBannerButton
